<div class="">
  @if (heading() || cta() || description()) {
    <div class="flex flex-col pt-2 lg:pt-4 pb-2 px-5 lg:px-12">
      <div class="flex justify-between items-center">
        @if (heading()) {
          <h2
            class="font-brand text-2xl lg:text-4xl [font-weight:700]"
            [style.color]="categoryNameColor() | contentBuilderColor"
          >
            {{ heading() }}
          </h2>
        }
        @if (cta()) {
          <a
            (click)="ctaClick.emit()"
            class="text-primary-600 font-sm font-bold cursor-pointer"
          >
            {{ cta() }}
            <i class="icon icon-arrow-right icon-16"></i>
          </a>
        }
      </div>
      @if (description()) {
        <p
          class="mt-3 text-sm md:text-base font-base"
          [style.color]="categoryDescriptionColor() | contentBuilderColor"
        >
          {{ description() }}
        </p>
      }
    </div>
  }
  @if (!isDesktop) {
    <ul class="flex overflow-x-auto scrollbar-hide mt-4 pb-8 px-5 lg:px-12">
      @for (product of products(); track product.id) {
        <li [class]="getMobileCardClass()">
          <app-product-card-atom
            [displayContext]="displayContext()"
            [product]="product"
            [isOrderingAllowed]="isOrderingAllowed()"
            [productNameColor]="productNameColor()"
            [productPriceColor]="productPriceColor()"
            [productImagePlaceholderColor]="productImagePlaceholderColor()"
            [productBorderColor]="productBorderColor()"
            [productBackgroundColor]="productBackgroundColor()"
            [productHoverColors]="productHoverColors()"
            (productClick)="productClick.emit(product)"
          ></app-product-card-atom>
        </li>
      }
    </ul>
  } @else {
    <div class="w-full mt-4 pb-8 px-5 lg:px-12">
      <app-card-carousel
        [cards]="products()"
        [nbDisplayCards]="desktopCarouselSlotCount()"
        [carouselItem]="productTemplate"
      ></app-card-carousel>

      <ng-template
        #productTemplate
        let-product
      >
        <div class="min-w-0 w-full items-stretch">
          <app-product-card-atom
            [displayContext]="displayContext()"
            [product]="product"
            [isOrderingAllowed]="isOrderingAllowed()"
            [productNameColor]="productNameColor()"
            [productPriceColor]="productPriceColor()"
            [productImagePlaceholderColor]="productImagePlaceholderColor()"
            [productBorderColor]="productBorderColor()"
            [productBackgroundColor]="productBackgroundColor()"
            [productHoverColors]="productHoverColors()"
            (productClick)="productClick.emit(product)"
          ></app-product-card-atom>
        </div>
      </ng-template>
    </div>
  }
</div>
